import { API_PORTFOLIO_MANAGEMENT_MODES } from 'src/tpbp-json-api-handler/models/contract/contract.types'
import type { ContractLineModel } from 'src/tpbp-json-api-handler/models/models'
import { PORTFOLIO_CONFIGURATION_PRODUCT_GROUP } from '../portfolio/portfolio.const'

export const ALLOWED_MANDATS_PRODUCT_GROUPS = new Set([
  PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.pea,
  PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.av,
])

export function isLifeInsuranceWithdrawalException(
  contractLine: ContractLineModel,
): boolean {
  return (
    contractLine.productGroup === PORTFOLIO_CONFIGURATION_PRODUCT_GROUP.av &&
    contractLine.contractManagementTypeInitial ===
      API_PORTFOLIO_MANAGEMENT_MODES.DISCRETIONARY &&
    contractLine.contractManagementType ===
      API_PORTFOLIO_MANAGEMENT_MODES.DISCRETIONARY &&
    contractLine.managementType ===
      API_PORTFOLIO_MANAGEMENT_MODES.SELF_MANAGED &&
    contractLine.isEligibleWithMandats === false &&
    !!contractLine.isArbitrable
  )
}
